import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { IS_STANDALONE } from 'domains/product-collection/constants'


const propTypes = {
  isStandalone: PropTypes.string
}

/**
 * @param {string} isStandalone
 */
const ProductCollectionIsStandaloneBadge = ({ isStandalone }) => {

  const colorMap = {
    [IS_STANDALONE.YES] : 'primary',
    [IS_STANDALONE.NO]  : 'info'
  }

  const color = colorMap[isStandalone] || 'default'

  return <StatusBadge color={ color } label={ isStandalone } />
}

ProductCollectionIsStandaloneBadge.propTypes = propTypes

export default ProductCollectionIsStandaloneBadge